import { render, staticRenderFns } from "./LandingPageEdit.vue?vue&type=template&id=0f9807a4&scoped=true"
import script from "./LandingPageEdit.vue?vue&type=script&lang=js"
export * from "./LandingPageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9807a4",
  null
  
)

export default component.exports